<div class="padding">

  <app-requested-reports-filter></app-requested-reports-filter>
  @if (repo.resource$ | async; as data) {
    <div>
      @if (data.length > 0) {
        <div class="table-container padding-top">
          <table mat-table matSort [dataSource]="this.repo.resource$" multiTemplateDataRows class="mat-elevation-z0"
            (matSortChange)="sort($event)" [class.table-loading]="this.repo.loading$ | async">
            <ng-container matColumnDef="reportName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="reportName"> {{ 'common.labels.report' | transloco }} </th>
              <td mat-cell *matCellDef="let report"> {{report.reportName}} </td>
            </ng-container>
            <ng-container matColumnDef="added">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="added"> {{ 'common.labels.requestedDate' | transloco }}
              </th>
              <td mat-cell *matCellDef="let report"> {{report.added | localizedDate: 'yyyy-MM-dd' }} </td>
            </ng-container>
            <ng-container matColumnDef="icon">
              <th mat-header-cell *matHeaderCellDef id="icon"> </th>
              <td mat-cell *matCellDef="let report">
                <div class="flex-container-center">
                  @if (!isComplete(report)) {
                    <mat-icon>{{ getIcon(report) }}</mat-icon>
                  } @else {
                    <div class="spinner-inline-container">
                      <div class="spinner-inline"> </div>
                    </div>
                  }
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="state">
              <th mat-header-cell *matHeaderCellDef mat-sort-header id="state"> {{ 'common.labels.state' | transloco }} </th>
              <td mat-cell *matCellDef="let report"> {{report.state}} </td>
            </ng-container>
            <ng-container matColumnDef="download">
              <th mat-header-cell *matHeaderCellDef id="download">
                <div class="flex-container-center">
                  {{ 'common.labels.result' | transloco }}
                </div>
              </th>
              <td mat-cell *matCellDef="let report">
                <div class="flex-container-center">
                  <button mat-flat-button color="primary" (click)="downloadDocument(report)"
                  [disabled]="!report.document">{{ 'common.buttons.download' | transloco }}</button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef [attr.aria-label]="'common.labels.rowActions' | transloco">&nbsp;</th>
              <td mat-cell *matCellDef="let report">
                <button mat-icon-button color="accent" (click)="onDelete(report)" [attr.aria-label]="'common.labels.deleteReport' | transloco">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
          </table>
          @if (((this.repo.loading$ | async) ?? false) && data.length === 0) {
            <div class="padding center padding-top-bottom-50"
              >
              &nbsp;
            </div>
          }
          <!-- Paginator for the bottom -->
          <div class="spacer-small"></div>
          @if (data.length > 0) {
            <mat-paginator [pageSize]="this.repo.pageSize$ | async"
              [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
            [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true" (page)="page($event)"></mat-paginator>
          }
        </div>
      }
      <lib-list-issue [repo]="this.repo" [data]="data"></lib-list-issue>
    </div>
  }
</div>